/**
 * @file patient.js
 *
 * Patient API Service
 *
 * API calls to /api/v1/patient.
 * Used by hooks (usePatients.js), never called directly from pages.
 */
import api from "./api";

export const patientService = {
  /** List all patients (professional/admin only). */
  getAll: () => api.get("/patient/list"),
  /** View one patient's profile by ID. */
  getById: (id) => api.get(`/patient/${id}`),
  /** Get logged-in patient's own profile. */
  getMe: () => api.get("/patient/me"),
  /** Update logged-in patient's own profile (e.g., dateOfBirth). */
  updateMe: (data) => api.put("/patient/me", data),
  /** Look up a patient by phone number (professional only). */
  lookupByPhone: (phone) => api.get("/patient/lookup-phone", { params: { phone } }),
  /** Professional creates a patient by providing name + contact info. */
  createByPro: (data) => api.post("/patient/create", data),
  /** Get patient's professionals (from appointment history). */
  getMyProfessionals: () => api.get("/patient/my-professionals"),
  /** Get patient dashboard stats (upcoming count, completed count, next appointment). */
  getMyStats: () => api.get("/patient/my-stats"),
};
